export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/onboarding-close.png?fcf97be80448bcc424c8d68916260499";